
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flow from 'vux/src/components/flow/flow.vue'
import FlowState from 'vux/src/components/flow/flow-state.vue'
import FlowLine from 'vux/src/components/flow/flow-line.vue'


import {Uploader} from 'vant';
import 'vant/lib/uploader/style'

export default {
name: "step3",
components: {
Group,
XButton,
Flow,
FlowState,
FlowLine,
Uploader
},
methods: {
next() {
this.$router.push('/uc/seller_recharge')
}
}
}



// WEBPACK FOOTER //
// ./src/components/sellerRequest/step3.vue